export { uk } from './i18n/uk';
